export default __webpack_public_path__ + "static/media/fuente.f784a734.jpg";